/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum SalesCallTypeFilter {
  Call = "Call",
  Visit = "Visit",
  Email = "Email",
  Video = "Video",
}

export function instanceOfSalesCallTypeFilter(value: any): boolean {
  for (const key in SalesCallTypeFilter) {
    if (Object.prototype.hasOwnProperty.call(SalesCallTypeFilter, key)) {
      if (
        SalesCallTypeFilter[key as keyof typeof SalesCallTypeFilter] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function SalesCallTypeFilterFromJSON(json: any): SalesCallTypeFilter {
  return SalesCallTypeFilterFromJSONTyped(json, false);
}

export function SalesCallTypeFilterFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SalesCallTypeFilter {
  return json as SalesCallTypeFilter;
}

export function SalesCallTypeFilterToJSON(
  value?: SalesCallTypeFilter | null,
): any {
  return value as any;
}

export function SalesCallTypeFilterToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): SalesCallTypeFilter {
  return value as SalesCallTypeFilter;
}
